module.exports = __webpack_public_path__ + "media/images/icons/bi-emoji-dizzy-9e497051fd6148f7774323e4730ae1c5.png";